import { UploadProps } from 'antd';
import Cookies from 'js-cookie';

import { baseURL } from './api-client';

export const getUploadCandidateFileProps = (): UploadProps => ({
  name: 'file',
  accept:
    '.pdf, .doc,.docx,.png,.jpeg,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  action: `${baseURL}/filestorage`,
  headers: {
    authorization: Cookies.get('token') || '',
    'X-Requested-With': null as unknown as string,
  },
});
